exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Kodchasan);", ""]);

// Module
exports.push([module.id, "\nhtml, body {\n    height: 100%;\n}\nbody {\n    font-family: 'Kodchasan', sans-serif;\n    transition: margin .5s ease-in-out;\n    background: #f9f9f9;\n}\nbutton {\n    outline: none !important;\n}\ndiv.non-existing-page-container {\n    min-height: 600px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n", ""]);

